const { range } = require("lodash");

const orgtree = {
  1: {
    name: "Super Admin",
    dependencies: {
      1: [],
    },
    type: 1,
  },
  2: {
    name: "State Admin",
    dependencies: {
      1: ["states"],
      2: ["states"],
    },
    type: 2,
  },
  3: {
    name: "Region Admin",
    dependencies: {
      1: ["states", "regions"],
      2: ["regions"],
      3: ["regions"],
    },
    type: 3,
  },
  4: {
    name: "Association Admin",
    dependencies: {
      1: ["states", "regions", "associations"],
      2: ["regions", "associations"],
      3: ["associations"],
      4: ["associations"],
    },
    type: 4,
  },
  5: {
    name: "Club Admin",
    dependencies: {
      1: ["states", "regions", "associations", "clubs"],
      2: ["regions", "associations", "clubs"],
      3: ["associations", "clubs"],
      4: ["clubs"],
      5: ["clubs"],
    },
    type: 5,
  },
  6: {
    name: "Team Admin",
    dependencies: {
      1: ["states", "regions", "associations", "clubs", "teams"],
      2: ["regions", "associations", "clubs", "teams"],
      3: ["associations", "clubs", "teams"],
      4: ["clubs", "teams"],
      5: ["teams"],
      6: ["teams"],
    },
    type: 6,
  },
  50: {
    name: "Gameday Admin",
    dependencies: {
      1: ["states", "regions", "associations"],
      2: ["regions", "associations"],
      3: ["associations"],
      4: ["associations"],
    },
    type: 50,
  },
  98: {
    name: "Game Dev Region Admin",
    dependencies: {
      1: ["game-dev-regions"],
    },
    type: 98,
  },
  99: {
    name: "Program Admin",
    dependencies: {
      1: ["game-dev-regions"],
      98: ["game-dev-regions"],
    },
    type: 99,
  },
  105: {
    name: "Club Program Admin",
    dependencies: {
      1: ["clubs"],
      5: ["clubs"],
    },
    type: 105,
  },
};

const roles = {
  superAdmin: 1,
  stateAdmin: 2,
  regionAdmin: 3,
  associationAdmin: 4,
  clubAdmin: 5,
  teamAdmin: 6,
  gamedayAdmin: 50,
  gamedevregionAdmin: 98,
  programAdmin: 99,
  clubProgramAdmin: 105,
};

const nationals = {
  TFA: 31,
  NRL: 32,
};

const errormsg = {
  phone: "Please enter a valid number",
  email: "Please enter a valid email",
  bad_movement: "Incomplete movement event",
  myactive_role: "Error deleting your current role",
  add_role: "Error adding a user role",
  delete_role: "Error deleting user role",
  pos_number: "Invalid position number",
  order_number: "Invalid order number",
  max_min: "Maximum age is lower than minimum age",
  price_decimal: "Price has more than 2 decimal places",
  age_overlap: "Overlapping age range",
  min_age: "Invalid minimum age",
  max_age: "Invalid maximum age",
  gte_age: "Age to must be at least equal to age from",
  price_overlap: "Overlapping prices",
  price_invalid: "Invalid price",
  select_option: "Please select an option",
  input_option: "Field is required",
  discount_amount: "Discount Amount must be a positive number",
  duplicate_team: "Home & Away team cannot be the same",
  draw_competitionpublished: "Draw for this competition has already been published",
  draw_compnovenue: "Compeititon has no venue",
  draw_alreadybuilt: "Draw for this competition already exists",
  draw_matches: "Matches already exist for this competition",
  draw_notenoughteam: "3 or more teams are required",
  draw_notenoughteam_in_pools: "3 or more teams are required in pools",
  draw_missingroundate: "Please complete all round dates",
  draw_finalneedmoreteam: "Not enough teams for the finals template selected",
  draw_invalidrounddatetime: "Invalid round date",
  draw_sameteam: "Home & Away team cannot be the same, except TBA",
  draw_tbabyematch: "Home & Away team cannot be TBA and BYE at the same time",
  regiproduct_invalidpercetageamount: "Discount amount must be under 100 for percentage type",
  regiproduct_invaliddiscountamount: "Invalid discount amount",
  regiproduct_invaliddiscountname: "Invalid discount name",
  regiproduct_overlap: "Overlapping discount date range",
  regiproduct_saleableitemsamename: "Found other items with same name",
  regiproduct_invaliddiscountfrom: "Invalid discount from date",
  regiproduct_invalidfamilydiscountfrom: "Invalid Regos From",
  regiproduct_invalidfamilydiscountto: "Invalid Regos To",
  image_format: "Only jpeg, jpg and png format are supported ",
  verification_confirm: "Please first check confirm box in order to verify this record",
  nrlid: "Invalid NRLID",
  same_position: "Player already in position",
  same_player: "Player on and off cannot be the same",
  dob_from: "Invalid date of birth from",
  dob_to: "Invalid date of birth to",
  gte_dob: "The To must be at least equal to the From",
  dob_overlap: "Overlapping dates of birth",
  gte_positive_zero: "Value must be a positive number or at least equal to 0",
  player_unavailable: "This player is currently unavailable",
  comp_overlapp: "Overlapping competition",
  no_internet_dispute: "Cannot dispute match because you are offline",
  no_internet_tl: "You are not connected to the internet",
  no_charge: "Charges are required for this competition case",
  player_on_req: "Player On required",
  player_off_req: "Player Off required",
  invalid_period: "Invalid period selected",
  no_shirt_num:
    "One or more players on the team list does not have a shirt number, please modify and resubmit",
  email_exist: "Email id already exist",
};

const ageLevels = [
  { name: "Under 4", min: 3, max: 4 },
  { name: "Under 5", min: 4, max: 5 },
  { name: "Under 6", min: 5, max: 6 },
  { name: "Under 7", min: 6, max: 7 },
  { name: "Under 8", min: 7, max: 8 },
  { name: "Under 9", min: 8, max: 9 },
  { name: "Under 10", min: 9, max: 10 },
  { name: "Under 11", min: 10, max: 11 },
  { name: "Under 12", min: 11, max: 12 },
  { name: "Under 13", min: 12, max: 13 },
  { name: "Under 14", min: 13, max: 14 },
  { name: "Under 15", min: 14, max: 15 },
  { name: "Under 16", min: 15, max: 16 },
  { name: "Under 17", min: 16, max: 17 },
  { name: "Under 18", min: 17, max: 18 },
  { name: "Seniors", min: 18, max: 99 },
  { name: "Masters", min: 34, max: 99 },
  { name: "All Ages", min: 4, max: 99 },
];

const memberTypes = [
  {
    name: "Player Tackle",
    type: "player",
    playing: true,
    stateType: "club-league",
    tfa: false,
  },
  {
    name: "Player Touch",
    type: "player-touch",
    playing: true,
    stateType: "club-league",
    tfa: true,
  },
  {
    name: "Player LeagueTag",
    type: "player-league-tag",
    playing: true,
    stateType: "club-league",
    tfa: false,
  },
  {
    name: "Player League Touch",
    type: "player-league-touch",
    playing: true,
    stateType: "club-league",
    tfa: false,
  },
  {
    name: "Player Representative",
    type: "player-representative",
    playing: true,
    stateType: "club-league",
    tfa: false,
  },
  {
    name: "Player Masters",
    type: "player-masters",
    playing: true,
    stateType: "club-league",
    tfa: false,
  },
  {
    name: "Player Social",
    type: "player-social",
    playing: true,
    stateType: "club-league",
    tfa: false,
  },
  {
    name: "Player School",
    type: "player-school",
    playing: true,
    stateType: "club-league",
    tfa: false,
  },
  {
    name: "Non-Participating Member",
    type: "non-participating-member",
    playing: false,
    stateType: "both",
    tfa: false,
  },
  {
    name: "Referee",
    type: "referee",
    playing: false,
    stateType: "referee",
    tfa: true,
  },
  {
    name: "Coach",
    type: "coach",
    playing: false,
    stateType: "both",
    tfa: true,
  },
  {
    name: "Volunteer",
    type: "volunteer",
    playing: false,
    stateType: "both",
    tfa: true,
  },
  {
    name: "Trainer",
    type: "trainer",
    playing: false,
    stateType: "club-league",
    tfa: false,
  },
];

const nonPlayerRoles = [
  {
    name: "Coach",
    type: "coach",
    memberType: "coach",
  },
  {
    name: "Assistant Coach",
    type: "assistant-coach",
    memberType: "coach",
  },
  {
    name: "Manager",
    type: "manager",
    memberType: "volunteer",
  },
  {
    name: "LeagueSafe",
    type: "trainer-1",
    memberType: "trainer",
  },
  {
    name: "League First-Aid",
    type: "trainer-2",
    memberType: "trainer",
  },
  {
    name: "Level 1",
    type: "trainer-3",
    memberType: "trainer",
  },
  {
    name: "Level 2",
    type: "trainer-4",
    memberType: "trainer",
  },
  // 1x Chief (CMO) & 1x Assistant (AMO)
  { name: "Chief (CMO)", type: "cmo", memberType: "trainer" },
  { name: "Assistant (AMO)", type: "amo", memberType: "trainer" },
];

const genders = ["Male", "Female", "All"];

const matchReports = [
  { name: "International Single Team Sheet", value: "int-single-team" },
  { name: "International Single Team - Opposition Summary", value: "int-single-team-opp-score" },
  { name: "Under 6-7 Single Team Sheet", value: "u6-u7-single" },
  { name: "Under 8-12 Single Team Sheet", value: "u8-u12-single" },
  { name: "Junior and International – Both Teams", value: "int-both-teams" },
];

const matchStatus = [
  { name: "Pre Game", type: "pre-game" },
  { name: "Final", type: "final" },
  { name: "Forfeit", type: "forfeit" },
  { name: "Disputed", type: "disputed" },
  { name: "Washed Out/Postponed", type: "washout" },
];

const nrlScoring = [
  { name: "Try", type: 38, value: 4 },
  { name: "Conversion Successful", type: 1, value: 2 },
  { name: "Conversion Unsuccessful", type: 2, value: 0 },
  { name: "Penalty Goal Successful", type: 67, value: 2 },
  { name: "Penalty Goal Unsuccessful", type: 68, value: 0 },
  { name: "1pt Field Goal Successful", type: 1000287, value: 1 },
  { name: "1pt Field Goal Unsuccessful", type: 1000300, value: 0 },
  { name: "2pt Field Goal Successful", type: 1000288, value: 2 },
  { name: "2pt Field Goal Unsuccessful", type: 1000301, value: 0 },
  { name: "Penalty Try", type: 99, value: 4 }, // Sent as 38 to STATS
];

const interchanges = [
  { name: "Regular Interchange", type: 10 },
  { name: "HIA Free Interchange", type: 11 },
  { name: "HIA Regular Play", type: 12 },
  { name: "HIA Return To Field", type: 13 },
  { name: "Sin Bin", type: 14 },
  { name: "Sin Bin Return To Field", type: 15 },
  { name: "Send Off/Dismissal", type: 16 },
  { name: "Free Interchange", type: 17 },
];

const tfaScoring = [{ name: "Try", type: 20, value: 1 }];

const finalTemplates = [
  {
    type: "2 Team 1 Week",
    teamnum: 2,
    matches: [
      {
        Match: 1,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Grand Final",
        matchup: "1 v 2",
      },
    ],
  },
  {
    type: "4 Team 2 Week",
    teamnum: 4,
    matches: [
      {
        Match: 1,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Semi Finals",
        matchup: "1 v 4 SF1",
      },
      {
        Match: 2,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Semi Finals",
        matchup: "2 v 3 SF2",
      },
      {
        Match: 3,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Grand Final",
        matchup: "WSF1 v WSF2 GF",
      },
    ],
  },
  {
    type: "4 Team 3 Week",
    teamnum: 4,
    matches: [
      {
        Match: 1,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Semi Finals",
        matchup: "3 v 4 SF1",
      },
      {
        Match: 2,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Semi Finals",
        matchup: "1 v 2 SF2",
      },
      {
        Match: 3,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Preliminary Final",
        matchup: "L2 v W1 PF",
      },
      {
        Match: 4,
        "Round Type": "Final",
        "Round Number": 3,
        "Round Display": "Grand Final",
        matchup: "W2 v W3 GF",
      },
    ],
  },
  {
    type: "4 Team 4 Week",
    teamnum: 4,
    matches: [
      {
        Match: 1,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "1st Semi Final",
        matchup: "3 v 4 SF1",
      },
      {
        Match: 2,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "2nd Semi Final",
        matchup: "1 v 2 SF2",
      },
      {
        Match: 3,
        "Round Type": "Final",
        "Round Number": 3,
        "Round Display": "Preliminary Final",
        matchup: "L2 v W1 PF",
      },
      {
        Match: 4,
        "Round Type": "Final",
        "Round Number": 4,
        "Round Display": "Grand Final",
        matchup: "W2 v W3 GF",
      },
    ],
  },
  {
    type: "5 Team 4 Week",
    teamnum: 5,
    matches: [
      {
        Match: 1,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "4 v 5 EF",
      },
      {
        Match: 2,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "2 v 3 QF",
      },
      {
        Match: 3,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Semi Finals",
        matchup: "L2 v W1 SF1",
      },
      {
        Match: 4,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Semi Finals",
        matchup: "1 v W2 SF2",
      },
      {
        Match: 5,
        "Round Type": "Final",
        "Round Number": 3,
        "Round Display": "Preliminary Final",
        matchup: "L4 v W3 PF",
      },
      {
        Match: 6,
        "Round Type": "Final",
        "Round Number": 4,
        "Round Display": "Grand Final",
        matchup: "W4 v W5 GF",
      },
    ],
  },
  {
    type: "6 Team 3 Week",
    teamnum: 6,
    matches: [
      {
        Match: 1,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "4 v 5 EF1",
      },
      {
        Match: 2,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "3 v 6 EF2",
      },
      {
        Match: 3,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Semi Finals",
        matchup: "1 v W1 SF1",
      },
      {
        Match: 4,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Semi Finals",
        matchup: "2 v W2 SF2",
      },
      {
        Match: 5,
        "Round Type": "Final",
        "Round Number": 3,
        "Round Display": "Grand Final",
        matchup: "W3 v W4 GF",
      },
    ],
  },
  {
    type: "6 Team 4 Week",
    teamnum: 6,
    matches: [
      {
        Match: 1,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "4 v 5",
      },
      {
        Match: 2,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "3 v 6",
      },
      {
        Match: 3,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Semi Finals",
        matchup: "1 v 2",
      },
      {
        Match: 4,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Semi Finals",
        matchup: "W1 v W2",
      },
      {
        Match: 5,
        "Round Type": "Final",
        "Round Number": 3,
        "Round Display": "Preliminary Final",
        matchup: "L3 v W4",
      },
      {
        Match: 6,
        "Round Type": "Final",
        "Round Number": 4,
        "Round Display": "Grand Final",
        matchup: "W3 v W5",
      },
    ],
  },
  {
    type: "8 Team 4 Week",
    teamnum: 8,
    matches: [
      {
        Match: 1,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "1 v 4 QF4",
      },
      {
        Match: 2,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "2 v 3 QF2",
      },
      {
        Match: 3,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "5 v 8 EF1",
      },
      {
        Match: 4,
        "Round Type": "Final",
        "Round Number": 1,
        "Round Display": "Elimination Finals",
        matchup: "6 v 7 EF2",
      },
      {
        Match: 5,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Semi Finals",
        matchup: "L1 v W2 SF1",
      },
      {
        Match: 6,
        "Round Type": "Final",
        "Round Number": 2,
        "Round Display": "Semi Finals",
        matchup: "L2 v W4 SF2",
      },
      {
        Match: 7,
        "Round Type": "Final",
        "Round Number": 3,
        "Round Display": "Preliminary Finals",
        matchup: "W2 v W5 PF1",
      },
      {
        Match: 8,
        "Round Type": "Final",
        "Round Number": 3,
        "Round Display": "Preliminary Finals",
        matchup: "W1 v W6 PF2",
      },
      {
        Match: 9,
        "Round Type": "Final",
        "Round Number": 4,
        "Round Display": "Grand Final",
        matchup: "W7 v W8 GF",
      },
    ],
  },
];

const teamListStatus = [
  { name: "Mid Week", type: "mid-week" },
  { name: "24 Hour", type: "24h" },
  { name: "1 Hour", type: "1h" },
  { name: "Final", type: "final" },
];

const entityType = [
  { name: "Club League", type: "club-league" },
  { name: "Referee", type: "referee" },
];

const uploadURL = `${process.env.VUE_APP_API_URL}/nrl/api/v1/admin/logo/upload`;
const supportDocumentURL = `${process.env.VUE_APP_API_URL}/nrl/api/v1/admin/upload-supporting-document`;
const headshotUploadURL = `${process.env.VUE_APP_API_URL}/nrl/api/v1/admin/headshot/upload`;

const sortBy = ["Total Points", "Points Difference", "Percentage"];

const dispensationTypes = [
  { type: "18 months registration window" },
  { type: "Weight for age" },
  { type: "Over 40 clearance" },
  { type: "Play above (1) age group consent" },
  { type: "Play above (2) age groups consent" },
  { type: "Play below (1) age group consent" },
  { type: "Play below (2) age groups consent" },
];

const dispensationRules = [
  { rule: "Participate (1) age group above" },
  { rule: "Participate (2) age groups above" },
  { rule: "Participate (1) age group below" },
  { rule: "Participate (2) age groups below" },
];

// All nrl past and current seasons
// const currentSeason = 2021;
const date = new Date();
const currentMonth = date.getMonth();
const currentSeason = currentMonth < 11 ? date.getFullYear() : date.getFullYear() + 1;

const allSeasons = range(currentSeason, 2000, -1).concat(1900);
const states = [
  "New South Wales",
  "Queensland",
  "South Australia",
  "Tasmania",
  "Victoria",
  "Western Australia",
  "Australian Capital Territory",
  "Northern Territory",
].map(x => ({ label: x, value: x }));

const wwcStatus = [
  { type: "active", name: "Active" },
  { type: "pending", name: "Pending" },
  { type: "expired", name: "Expired" },
  { type: "barred", name: "Barred" },
];

const autoApprovals = [
  { type: 1, name: "Inward Only" },
  { type: 2, name: "Outward Only" },
  { type: 3, name: "Both Inward and Outward" },
];

const registrationStatus = [
  { type: "all", name: "All" },
  { type: "active", name: "Active (Registered in current season)" },
  { type: "inactive", name: "Inactive (Not registered in current season)" },
];

const gamePeriods = [
  { name: "First Half", type: 1 },
  { name: "Second Half", type: 2 },
  { name: "Extra Time", type: 3 },
];

const gameStates = [
  { name: "First Half", type: 3 },
  { name: "Half Time", type: 4 },
  { name: "Second Half", type: 5 },
  { name: "Extra Time", type: 6 },
  { name: "Final", type: 8 },
];

const compFeeTypes = [
  { name: "Team Pays", type: 1 },
  { name: "Player Pays", type: 2 },
];

const grassrootGameStates = [
  { name: "Period 1", type: 20 },
  { name: "Period 2", type: 21 },
  { name: "Period 3", type: 22 },
  { name: "Period 4", type: 23 },
  { name: "Extra Time", type: 24 },
  { name: "Final", type: 25 },
];
const grassrootGameStatesTypes = grassrootGameStates.map(s => s.type);

// Variables
const vestTypes = [
  {
    name: "First Receiver",
    type: "FR",
    ageLvls: ["Under 8", "Under 9", "Under 10", "Under 11", "Under 12"],
  },
  {
    name: "Dummy Half",
    type: "DH",
    ageLvls: ["Under 9", "Under 10", "Under 11", "Under 12"],
  },
];

const caseCharges = [
  {
    type: 1,
    name: "1.e Behave in anyway contrary to the ARL Code of conduct and/or the spirit of the game",
  },
  {
    type: 2,
    name: "1.f Behave in anyway which disturbs the enjoyment of the match/discredits the home club and/or league",
  },
  {
    type: 3,
    name: "1.g Act in such a way as to exhibit racial intolerance, by language or other conduct",
  },
  {
    type: 4,
    name: "1.h Refuse to accept the reasonable direction of the Ground Manager, or club, league, team officials",
  },
  {
    type: 5,
    name: "1.i No person/s may make comment or take actions that bring discredit to any person, Club or league through any social media outlet",
  },
  { type: 6, name: "15.1.a Trips, Kicks, Strikes" },
  { type: 7, name: "15.1.b Contact head/neck" },
  { type: 8, name: "15.1.c Drops Knees" },
  { type: 9, name: "15.1.d Dangerous Throw" },
  { type: 10, name: "15.1.e Deliberately & Continuously breaks the Laws of the Game" },
  { type: 11, name: "15.1.f Offensive or obscene language" },
  { type: 12, name: "15.1.g Disputes decision by match official" },
  { type: 13, name: "15.1.h Re-enters the field without permission" },
  { type: 14, name: "15.1.i Behaves contrary to the spirit of the game" },
  { type: 15, name: "15.1.j Deliberately obstructs an opponent who is not in possession" },
  { type: 16, name: "15.1.k Uses a shoulder charge on an opponent" },
  {
    type: 17,
    name: "15.1.l Applies any unnecessary pressure or twist including grapples, crushers or performs a chicken wing style hold on a player in possession.",
  },
  {
    type: 18,
    name: "15.1.m Forcefully spears at the legs of a player in possession, exposing him to unnecessary risk of injury.",
  },
  { type: 19, name: "Careless High Tackle" },
  { type: 20, name: "Contrary Conduct" },
  { type: 21, name: "Dangerous Contact (Head/Neck)" },
  { type: 37, name: "Dangerous Contact (Other)" },
  { type: 22, name: "Dangerous Throw" },
  { type: 23, name: "Detrimental Conduct" },
  { type: 24, name: "Disputing Decision" },
  { type: 25, name: "Dropping Knees" },
  { type: 26, name: "Intentional High Tackle" },
  { type: 27, name: "Kicking" },
  { type: 28, name: "Law Breaking" },
  { type: 29, name: "Obstructing" },
  { type: 30, name: "Offensive Language" },
  { type: 31, name: "Other - Breach of Constitution/By-Laws/Rules and Regulations" },
  { type: 32, name: "Reckless High Tackle" },
  { type: 33, name: "Re-entering Play" },
  { type: 34, name: "Shoulder Charge" },
  { type: 35, name: "Striking" },
  { type: 36, name: "Tripping" },
];

const compCasesTypes = [
  { type: 1, name: "Tribunal" },
  { type: 2, name: "Injury" },
];

const disabilityTypes = [
  "Vision Impairment",
  "Hearing Impairment",
  "Intellectual disability",
  "Autism",
  "Asperger's Syndrome",
  "Cerebral Palsy",
  "Spina Bifida",
  "Spinal Cord Injury",
  "Amputation",
  "Other",
].map(x => ({ label: x, value: x }));

const injuryNatureList = [
  { option: "Bruise / Contusion", value: "Bruise / Contusion" },
  { option: "Bleeding", value: "Bleeding" },
  { option: "Cardiac Problem", value: "Cardiac Problem" },
  { option: "Breast or chest tissue injury", value: "Breast or chest tissue injury" },
  { option: "Dislocation / Subluxation", value: "Dislocation / Subluxation" },
  { option: "Fracture", value: "Fracture" },
  { option: "Heat-Related Illness", value: "Heat-Related Illness" },
  { option: "Inflammation / Swelling", value: "Inflammation / Swelling" },
  { option: "Respiratory Problem", value: "Respiratory Problem" },
  { option: "Skin Injury", value: "Skin Injury" },
  { option: "Strain", value: "Strain" },
  { option: "Sprain", value: "Sprain" },
  { option: "Suspected Spinal Injury", value: "Suspected Spinal Injury" },
  { option: "Suspected Concussion", value: "Suspected Concussion" },
  { option: "Other", value: "Other" },
];

const howPlayerInjuredList = [
  { option: "Non-tackle collision", value: "Non-tackle collision" },
  { option: "Non-contact - running/side stepping", value: "Non-contact - running/side stepping" },
  { option: "Foul Play", value: "Foul Play" },
  { option: "Making a tackle - tackler", value: "Making a tackle - tackler" },
  { option: "Getting tackled - ball carrier", value: "Getting tackled - ball carrier" },
  { option: "Other", value: "Other" },
];

const playerSelfStateList = [
  { option: "No different", value: "No different" },
  { option: "Very different", value: "Very different" },
  { option: "Unsure", value: "Unsure" },
  { option: "Not applicable", value: "Not applicable" },
];

const playerRemoveList = [
  { option: "Assisted", value: "Assisted" },
  { option: "Ambulance", value: "Ambulance" },
  { option: "Completed Match/Training", value: "Completed Match/Training" },
  { option: "Stretcher", value: "Stretcher" },
  { option: "Walked", value: "Walked" },
];

const playerRefferedList = [
  { option: "Ambulance", value: "Ambulance" },
  { option: "Doctor", value: "Doctor" },
  { option: "Hospital", value: "Hospital" },
  { option: "Physiotherapist", value: "Physiotherapist" },
  { option: "Other", value: "Other" },
];

const immediateCareList = [
  { option: "CPR", value: "CPR" },
  { option: "Dressing", value: "Dressing" },
  { option: "Immobilisation", value: "Immobilisation" },
  { option: "None given", value: "None given" },
  {
    option: "Rest, Ice, Compression, Elevation, Referral",
    value: "Rest, Ice, Compression, Elevation, Referral",
  },
  { option: "Sling/Splint", value: "Sling/Splint" },
  { option: "Strapping/Taping", value: "Strapping/Taping" },
  { option: "Other", value: "Other" },
];

const firstResponderRoleList = [
  { option: "League First Aid", value: "League First Aid" },
  { option: "Level 1 Sports Trainer", value: "Level 1 Sports Trainer" },
  { option: "Level 2 Sports Trainer", value: "Level 2 Sports Trainer" },
  { option: "CMO", value: "CMO" },
  { option: "AMO", value: "AMO" },
];

const yesOrNo = [
  { option: "Yes", value: true },
  { option: "No", value: false },
];

const yesNoOptions = [
  { option: "Yes -Observed", value: "Yes -Observed" },
  { option: "Yes -Reported", value: "Yes -Reported" },
  { option: "No", value: "No" },
];

module.exports = {
  orgtree,
  errormsg,
  ageLevels,
  finalTemplates,
  roles,
  memberTypes,
  nonPlayerRoles,
  uploadURL,
  supportDocumentURL,
  headshotUploadURL,
  genders,
  matchStatus,
  nrlScoring,
  tfaScoring,
  interchanges,
  teamListStatus,
  entityType,
  nationals,
  sortBy,
  dispensationTypes,
  dispensationRules,
  allSeasons,
  currentSeason,
  states,
  wwcStatus,
  autoApprovals,
  registrationStatus,
  matchReports,
  gamePeriods,
  compFeeTypes,
  gameStates,
  grassrootGameStates,
  grassrootGameStatesTypes,
  vestTypes,
  caseCharges,
  compCasesTypes,
  disabilityTypes,
  injuryNatureList,
  howPlayerInjuredList,
  playerSelfStateList,
  playerRemoveList,
  playerRefferedList,
  immediateCareList,
  firstResponderRoleList,
  yesOrNo,
  yesNoOptions,
};
